import React from 'react'

const   PageCountSelect = ({rowsPerPage,handleRowsChange}) => {
    return (
        <div className="d-md-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
            <div className="dt-length mb-md-6 mb-0">
                <select value={rowsPerPage} onChange={handleRowsChange} name="DataTables_Table_0_length" className="form-select ms-0" id="dt-length-0">
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
                <label htmlFor="dt-length-0" />
            </div>
        </div>
    )
}

export default PageCountSelect
